import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export const useLocalStorage = <T>(
  key: string,
  fallbackValue: T
): [T, Dispatch<SetStateAction<T>>] => {
  const [value, setValue] = useState<T>(fallbackValue);
  useEffect(() => {
    const stored = localStorage.getItem(key);
    setValue(
      stored && stored !== 'undefined' ? JSON.parse(stored) : fallbackValue
    );
  }, [fallbackValue, key]);

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
};
